import { render, staticRenderFns } from "./OpenUserTasks.vue?vue&type=template&id=69f7a5e7"
import script from "./OpenUserTasks.vue?vue&type=script&lang=ts"
export * from "./OpenUserTasks.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports